import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';

export interface QueryBuilderState {
  data: { [key: string]: any };
  error: ErrorObject;
}

const initialState = {
  data: {}
} as QueryBuilderState;

export default initialState;
